// extracted by mini-css-extract-plugin
var _1 = "j9_xUaFA";
export { _1 as "newPostBtn" }
